export const ACCEPTED_FORMATS = '.pdf,.tiff,.tif,.jpeg,.jpg,.png'

export const ACCEPTED_MIME_TYPES = [
  'application/pdf',
  'image/tiff',
  'image/jpeg',
  'image/jpg',
  'image/png',
]

export const DROP_ZONE_TEXT = {
  title: 'Drop requisition files here',
  subtitle: 'or click to browse',
  formats: 'Supports PDF, JPEG, TIFF, PNG',
} as const
